<template>
  <div>
    <!---->
    <b-row>
      <b-col md="5" offset-md="3">
        <b-card no-body class="border mb-1">
          <b-card-body class="p-2 m-0 ">
            <b-card-title class="p-1 m-0 text-center ">
              {{ $t("roadmap.stage.kvkk-platform-stages-completed") }}
            </b-card-title>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isProductTutorialStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.kvkk-product-tutorial") }}</b-card-title>

          <content-loading v-if="isProductTutorialLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionProductTutorial"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksProductTutorial" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementKvkkRoadmap" stage="KVKK_PRODUCT_TUTORIAL" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isDepartmentQuestionsStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.kvkk-department-questions") }}</b-card-title>

          <content-loading v-if="isDepartmentQuestionsLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionDepartmentQuestions"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksDepartmentQuestions" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementKvkkRoadmap" stage="KVKK_DEPARTMENT_QUESTIONS" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isInventoryUpdateStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.kvkk-inventory-update") }}</b-card-title>

          <content-loading v-if="isInventoryUpdateLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionInventoryUpdate"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksInventoryUpdate" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementKvkkRoadmap" stage="KVKK_INVENTORY_UPDATE" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isKvkkPolicyStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.kvkk-policy") }}</b-card-title>

          <content-loading v-if="isKvkkPolicyLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionKvkkPolicy"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksKvkkPolicy" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementKvkkRoadmap" stage="KVKK_POLICY" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isKvkkRiskStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.kvkk-risk") }}</b-card-title>

          <content-loading v-if="isKvkkRiskLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionKvkkRisk"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksKvkkRisk" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementKvkkRoadmap" stage="KVKK_RISK" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isReportPrepareStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.kvkk-report-prepare") }}</b-card-title>
          <content-loading v-if="isReportPrepareLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionReportPrepare"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksReportPrepare" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementKvkkRoadmap" stage="KVKK_REPORT_PREPARE" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <hr />
    <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>
  </div>
</template>

<script>
import RoadmapStageTaskForm from "./component/roadmap-stage-task-form";
const state = "managementKvkkRoadmap";

export default {
  components: { RoadmapStageTaskForm },
  data() {
    return {};
  },

  computed: {
    descriptionProductTutorial: {
      get() {
        return this.$store.getters[`${state}/descriptionProductTutorial`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionProductTutorial`, v);
      },
    },
    descriptionDepartmentQuestions: {
      get() {
        return this.$store.getters[`${state}/descriptionDepartmentQuestions`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionDepartmentQuestions`, v);
      },
    },
    descriptionInventoryUpdate: {
      get() {
        return this.$store.getters[`${state}/descriptionInventoryUpdate`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionInventoryUpdate`, v);
      },
    },
    descriptionKvkkPolicy: {
      get() {
        return this.$store.getters[`${state}/descriptionKvkkPolicy`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionKvkkPolicy`, v);
      },
    },
    descriptionKvkkRisk: {
      get() {
        return this.$store.getters[`${state}/descriptionKvkkRisk`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionKvkkRisk`, v);
      },
    },
    descriptionReportPrepare: {
      get() {
        return this.$store.getters[`${state}/descriptionReportPrepare`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionReportPrepare`, v);
      },
    },

    //
    editedStages() {
      return this.$store.getters[`${state}/editedStages`];
    },
    isProductTutorialStageEdited() {
      return this.editedStages.includes("KVKK_PRODUCT_TUTORIAL");
    },
    isDepartmentQuestionsStageEdited() {
      return this.editedStages.includes("KVKK_DEPARTMENT_QUESTIONS");
    },
    isInventoryUpdateStageEdited() {
      return this.editedStages.includes("KVKK_INVENTORY_UPDATE");
    },
    isKvkkPolicyStageEdited() {
      return this.editedStages.includes("KVKK_POLICY");
    },
    isKvkkRiskStageEdited() {
      return this.editedStages.includes("KVKK_RISK");
    },
    isReportPrepareStageEdited() {
      return this.editedStages.includes("KVKK_REPORT_PREPARE");
    },
    //
    isInventoryUpdateLoading() {
      return this.$store.getters[`${state}/isInventoryUpdateLoading`];
    },
    isDepartmentQuestionsLoading() {
      return this.$store.getters[`${state}/isDepartmentQuestionsLoading`];
    },
    isProductTutorialLoading() {
      return this.$store.getters[`${state}/isProductTutorialLoading`];
    },
    isKvkkPolicyLoading() {
      return this.$store.getters[`${state}/isKvkkPolicyLoading`];
    },
    isKvkkRiskLoading() {
      return this.$store.getters[`${state}/isKvkkRiskLoading`];
    },
    isReportPrepareLoading() {
      return this.$store.getters[`${state}/isReportPrepareLoading`];
    },

    //
    tasks() {
      return this.$store.getters[`${state}/tasks`];
    },
    tasksProductTutorial() {
      return this.tasks.filter((i) => i.stage == "KVKK_PRODUCT_TUTORIAL");
    },
    tasksDepartmentQuestions() {
      return this.tasks.filter((i) => i.stage == "KVKK_DEPARTMENT_QUESTIONS");
    },
    tasksInventoryUpdate() {
      return this.tasks.filter((i) => i.stage == "KVKK_INVENTORY_UPDATE");
    },
    tasksKvkkPolicy() {
      return this.tasks.filter((i) => i.stage == "KVKK_POLICY");
    },
    tasksKvkkRisk() {
      return this.tasks.filter((i) => i.stage == "KVKK_RISK");
    },
    tasksReportPrepare() {
      return this.tasks.filter((i) => i.stage == "KVKK_REPORT_PREPARE");
    },
    //
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
  },
  mounted() {
    this.loadStages();
    window.addEventListener("beforeunload", this.beforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    const answer = window.confirm("Do you really want to leave? you have unsaved changes!");
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },

  methods: {
    beforeUnload(e) {
      if (this.editedStages.length == 0) {
        return undefined;
      }

      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },

    loadStages() {
      return this.$store.dispatch(`${state}/loadStages`);
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/save`);
        this.loadStages();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    removeTaskItem(task) {
      this.$store.commit(`${state}/removeTaskItem`, { task });
    },
    editTaskItem(task) {
      this.$store.commit(`${state}/editedTask`, { ...task });

      this.$root.$emit("bv::toggle::collapse", `sidebar-create-task-` + task.stage);
    },
  },
};
</script>
